import { NgModule } from '@angular/core';
import { HttpClientModule } from "@angular/common/http";

import { ViewModule } from 'app/views/view.module';
import { DataProvider2 } from 'app/provider/data2.provider';

import { CacheInfoComponent } from 'app/support/cache_info/cache_info.component';
import { GroupRefComponent } from 'app/support/group_ref/group_ref.component';
import { SupportComponent} from "app/support/support/support.component";
import {LogsModalComponent} from "./support/modals/logs.component";
import {SetPremiumTemplatesModalComponent} from "./support/modals/set_premium_templates.component";
import {GroupRefService} from "./group_ref/group_ref.service";
import {SetProModalComponent} from "./support/modals/set_pro.component";
import {RestorePasswordModalComponent} from "./support/modals/restore_password.component";
import {SetPasswordModalComponent} from "./support/modals/set_password.component";
import {SetRoleModalComponent} from "./support/modals/set_role.component";
import {SetUserBanModalComponent} from "./support/modals/set_user_ban.component";
import {SetUnBanModalComponent} from "./support/modals/set_unban.component";
import {RenewTrialModalComponent} from "./support/modals/renew_trial.component";
import {SetSiteBlockModalComponent} from "./support/modals/set_site_block.component";
import {SetSiteUnBlockModalComponent} from "./support/modals/set_site_unblock.component";
import {AttachTariffModalComponent} from "./support/modals/attach_tariff.component";
import {ChangeOwnerModalComponent} from "./support/modals/change_owner.component";
import {ChangeTariffModalComponent} from "./support/modals/change_tariff.component";
import {BaseSupportModalComponent} from "./support/modals/base_support.component";
import {NgbActiveModal, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {TransferInvoiceModalComponent} from "./support/modals/transfer_invoice.component";
import {RemoveInvoiceModalComponent} from "./support/modals/remove_invoice.component";
import {EditSiteModalComponent} from "./support/modals/edit_site.component";
import {RenewTariffModalComponent} from "./support/modals/renew_tariff.component";
import {RemoveSiteModalComponent} from "./support/modals/remove_site.component";
import {ChangeLangModalComponent} from "./support/modals/change_lang.component";
import {BreakPublishModalComponent} from "./support/modals/break_publish.component";
import {SeoUberModalComponent} from "./support/modals/seo_uber.component";
import {SetFreemiumUserModalComponent} from "./support/modals/set_freemium_user.component";
import {SetFreemiumSiteModalComponent} from "./support/modals/set_freemium_site.component";
import {SetUberTariffModalComponent} from "./support/modals/set_uber_tariff.component";
import {SetDivlyIdModalComponent} from "./support/modals/set_divly_id.component";
import {AccessorComponent} from "./accessor/accessor.component";
import {AccessorService} from "./accessor/accessor.service";
import {AccessorStatsModalComponent} from "./accessor/stats.component";
import {AccessorMyStatsModalComponent} from "./accessor/mystats.component";
import {AccessorPersonalStatsModalComponent} from "./accessor/personal_stats.component";
import {AccessorManageModalComponent} from "./accessor/manage.component";
import {AccessorSiteStatsModalComponent} from "./accessor/site_stats.component";
import {StartCacheInfoComponent} from "./cache_info/start_cache_info.component";
import {CacheInfoService} from "./cache_info/cache_info.service";
import {BanSitesByListModalComponent} from "./support/modals/ban_sites_by_list.component";
import {CheckForDivlyModalComponent} from "./support/modals/check_for_divly.component";
import {ModalSpreaderService} from "./support/modals/modal_spreader_service";
import {ReactiveFormsModule} from "@angular/forms";
import {RestoreSiteModalComponent} from "./support/modals/restore_site.component";
import {EditRecurrentModalComponent} from "./support/modals/edit_recurrent.component";
import {SetDivlyLabelModalComponent} from "./support/modals/set_divly_label.component";
import {DisableRecurrentModalComponent} from "./support/modals/disable_recurrent.component";
import {UserReRegInfoModalComponent} from "./support/modals/rereg_modal.component";
import {ReturnPaidComponent} from "./support/modals/return_paid";
import {ChangeCurrencyModalComponent} from "./support/modals/change_currency.component";
import {SiteHistoryModal} from "./support/modals/site_history_modal.component";
import {SetMultilangCloneModalComponent} from "./support/modals/set_multilang_clone.component";
import {CloneSiteModalComponent} from "./support/modals/clone_site.component";
import { SetExcludeFromStatsComponent } from "./support/modals/set_exclude_from_stats";
import { PromoputlModalComponent } from "./support/modals/promoputl.component";
import {FixWidgetsModalComponent} from "./support/modals/fix-widgets.component";
import {SiteFilesModalComponent} from "./support/modals/site_files.component";

@NgModule({
	imports: [
		ViewModule,
		HttpClientModule,
		NgbModule,
		ReactiveFormsModule.withConfig({warnOnNgModelWithFormControl: 'never'})
	],

	declarations: [
		BaseSupportModalComponent,
		CacheInfoComponent,
		GroupRefComponent,
		SupportComponent,
		AccessorComponent,
		LogsModalComponent,
		SetPremiumTemplatesModalComponent,
		SetProModalComponent,
		RestorePasswordModalComponent,
		SetPasswordModalComponent,
		SetRoleModalComponent,
		SetUserBanModalComponent,
		SetUnBanModalComponent,
		RenewTrialModalComponent,
		SetSiteBlockModalComponent,
		SetSiteUnBlockModalComponent,
		AttachTariffModalComponent,
		ChangeOwnerModalComponent,
		ChangeTariffModalComponent,
		TransferInvoiceModalComponent,
		RemoveInvoiceModalComponent,
		EditSiteModalComponent,
		RenewTariffModalComponent,
		RemoveSiteModalComponent,
		ChangeLangModalComponent,
		BreakPublishModalComponent,
		SeoUberModalComponent,
		SetFreemiumUserModalComponent,
		SetFreemiumSiteModalComponent,
		SetUberTariffModalComponent,
		SetDivlyIdModalComponent,
		SetDivlyLabelModalComponent,
		BanSitesByListModalComponent,
		CheckForDivlyModalComponent,
		AccessorStatsModalComponent,
		AccessorMyStatsModalComponent,
		AccessorPersonalStatsModalComponent,
		AccessorManageModalComponent,
		AccessorSiteStatsModalComponent,
		StartCacheInfoComponent,
		RestoreSiteModalComponent,
		EditRecurrentModalComponent,
		DisableRecurrentModalComponent,
		UserReRegInfoModalComponent,
		ReturnPaidComponent,
		ChangeCurrencyModalComponent,
		SiteHistoryModal,
		SetMultilangCloneModalComponent,
		CloneSiteModalComponent,
		SetExcludeFromStatsComponent,
		PromoputlModalComponent,
		FixWidgetsModalComponent,
		SiteFilesModalComponent
	],

	providers: [
		GroupRefService,
		AccessorService,
		NgbActiveModal,
		CacheInfoService,
		ModalSpreaderService,
		DataProvider2
	],
	
	entryComponents: [
		BaseSupportModalComponent,
		LogsModalComponent,
		SetPremiumTemplatesModalComponent,
		SetProModalComponent,
		RestorePasswordModalComponent,
		SetPasswordModalComponent,
		SetRoleModalComponent,
		SetUserBanModalComponent,
		SetUnBanModalComponent,
		RenewTrialModalComponent,
		SetSiteBlockModalComponent,
		SetSiteUnBlockModalComponent,
		AttachTariffModalComponent,
		ChangeOwnerModalComponent,
		ChangeTariffModalComponent,
		TransferInvoiceModalComponent,
		RemoveInvoiceModalComponent,
		EditSiteModalComponent,
		RenewTariffModalComponent,
		RemoveSiteModalComponent,
		ChangeLangModalComponent,
		BreakPublishModalComponent,
		SeoUberModalComponent,
		SetFreemiumUserModalComponent,
		SetFreemiumSiteModalComponent,
		SetUberTariffModalComponent,
		SetDivlyIdModalComponent,
		SetDivlyLabelModalComponent,
		BanSitesByListModalComponent,
		CheckForDivlyModalComponent,
		AccessorStatsModalComponent,
		AccessorMyStatsModalComponent,
		AccessorPersonalStatsModalComponent,
		AccessorManageModalComponent,
		AccessorSiteStatsModalComponent,
		StartCacheInfoComponent,
		RestoreSiteModalComponent,
		EditRecurrentModalComponent,
		DisableRecurrentModalComponent,
		UserReRegInfoModalComponent,
		ReturnPaidComponent,
		ChangeCurrencyModalComponent,
		SiteHistoryModal,
		SetMultilangCloneModalComponent,
		CloneSiteModalComponent,
		SetExcludeFromStatsComponent,
		PromoputlModalComponent,
		FixWidgetsModalComponent,
		SiteFilesModalComponent
	]
})
export class SupportModule { }
